"use client";

import React, { useState } from "react";
import ListingPageMobileFilterComponent from "./ListingPageMobileFilterComponent";
import SelectedOptionsSection from "./components/SelectedOptionsSection";

const ListingPageMobileFilter = ({
  filterOptions,
  filterData,
  collegesUrl,
  location,
  availableStreams,
  filterSecStreamData,
}: any) => {
  const [isModelOpen, setIsModelOpen] = useState<boolean>(false);

  // Local state for selected filter category
  const [selectedFilterCategory, setSelectedFilterCategory] = useState<string | null>(null);

  // set selectedFilterCategory to "country" or "state" by default for mobile:
  const option =
    filterOptions?.country?.country_url !== "study-in-india"
      ? "country"
      : "state";

  // Accept a filter key to open after redirect
  const handleModalToggle = (filterKey?: string) => {
    setIsModelOpen((prev) => !prev);
    if (!isModelOpen) {
      setSelectedFilterCategory(filterKey || option);
    } else {
      setSelectedFilterCategory(null);
    }
  };

  return (
    <div className="mt-2">
      <div className="flex gap-2 h-9 w-full justify-center items-center">
        <button
          className="flex items-center gap-x-0.5 bg-[#334988] text-white rounded-full px-4 text-sm min-w-fit py-1"
          onClick={() => handleModalToggle()}
        >
          <h3 className="">Filter By</h3>
        </button>

        {/* here print a list in a straight line */}
        <div className="overflow-auto w-72 sm:w-full hide-scrollbar">
          <SelectedOptionsSection
            setSelectedFilterCategory={setSelectedFilterCategory}
            filterOptions={filterOptions}
            collegesUrl={collegesUrl}
            location={location}
          />
        </div>
      </div>

      {/* Filter Section - Bottom Sheet */}
      {isModelOpen && (
        <ListingPageMobileFilterComponent
          filterOptions={filterOptions}
          selectedFilterCategory={selectedFilterCategory}
          setSelectedFilterCategory={setSelectedFilterCategory}
          filterData={filterData}
          collegesUrl={collegesUrl}
          location={location}
          availableStreams={availableStreams}
          filterSecStreamData={filterSecStreamData}
          handleModalToggle={handleModalToggle}
        />
      )}
    </div>
  );
};

export default ListingPageMobileFilter;
